import { ContentType } from "./http-client";

export class TrustDeposits {
  constructor(http) {
    this.http = http;
  }

  getTrustDeposits = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/trust`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  registerTrustDeposit = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/trust`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  calculateInterest = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/interest/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  calculateSettlement = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/settlement/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  payoutInterest = (rentalId, interestId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/interest/${interestId}/payout`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  updateDepositStatus = (rentalId, depositId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/deposits/${depositId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
